// "02 · Selected work" on home, and "Trajectory" on the practice view.

const WORK_RANGE = "2006–2026";

const SELECTED_WORK = [
	{
		index: "01",
		company: "ServiceNow",
		description:
			"Product architecture for agentic evaluation and red teaming on the AI Agents Platform, a reusable bring-your-own-guardrails framework, and AI-native workflows for Fortune 500 and Fortune 100 enterprises.",
		role: "Principal Architect, Applied AI",
		years: "2025–present",
	},
	{
		index: "02",
		company: "Amazon Web Services",
		description:
			"Product architecture and go-to-market for Textract, Q Business and Bedrock; five production generative AI applications and ten-plus enterprise document intelligence systems; open-source frameworks and a curriculum reaching 1.2M learners.",
		role: "Sr. GenAI Specialist SA",
		years: "2020–2025",
	},
	{
		index: "03",
		company: "Petco",
		description:
			"Computer vision for companion animal health, serverless document processing into the ERP, and SRM and PLM platforms licensed as SaaS at 4.85M USD annual ROI across AWS and GCP.",
		role: "Manager, Domain Architecture",
		years: "2012–2020",
	},
	{
		index: "04",
		company: "Oracle",
		description:
			"Enterprise retail implementations and consulting on Oracle applications.",
		role: "Senior Managing Consultant",
		years: "2010–2011",
	},
	{
		index: "05",
		company: "IBM",
		description:
			"Oracle Retail ERP for merchandising and demand forecasting: requirements, module development, testing and technical documentation.",
		role: "Package Solution Architect",
		years: "2006–2010",
	},
];

// Four entries, progressively collapsing. `tone` drives the date colour:
// accent for the current role, sec for the middle two, dim for the historical block.
const TRAJECTORY = [
	{
		years: "2025–present",
		tone: "accent",
		title: "Principal Solutions Architect, Applied AI",
		meta: "ServiceNow · Forward Deployed Engineering · San Diego",
		description:
			"Product architecture lead for agentic evaluation and red teaming on the AI Agents Platform, and architecture advisory for Document Intelligence. Embedded with CIO, CTO and CHRO stakeholders to turn ambiguous requirements into production AI workflows.",
	},
	{
		years: "2020–2025",
		tone: "sec",
		title: "Sr. GenAI Specialist Solutions Architect",
		meta: "Amazon Web Services · Worldwide Specialist Org, AI & ML",
		description:
			"Owned the full lifecycle of AI adoption across Fortune 500 enterprises, mid-market and startups: executive alignment, solution design, implementation, outcome. Led applied research in intelligent document processing and shaped AWS AI product features through customer engagements. Authored 20+ technical articles and reference architectures, and two books.",
	},
	{
		years: "2012–2020",
		tone: "sec",
		title: "Manager, Domain Architecture, then Lead Application Architect",
		meta: "Petco · OneView SRM & PLM, IaC and cloud migration",
		description:
			"Eight years of platform ownership: computer vision for pet health, serverless document processing into the ERP, SRM and PLM platforms licensed as SaaS at 4.85M USD annual ROI, and the analytics infrastructure underneath merchandising, supply chain and finance. Distributed teams across the US, Brazil and India.",
	},
	{
		years: "2006–2012",
		tone: "dim",
		collapsed: true,
		title: "Lead Engineer at Mills Wholesale Supply; Application Consultant at IBM India; Programmer Analyst at Cognizant",
		description:
			"Oracle Retail ERP for merchandising and demand forecasting, system integrations for omnichannel retail, and distributed teams across India, the Philippines and Mexico.",
	},
];

export { WORK_RANGE, SELECTED_WORK, TRAJECTORY };
